import {
  ImageWithLoader,
  LoadingIndicator,
  Routes,
  TERMS_CONDITIONS_URL,
} from '@xolv-mybrightlink/common';
import { Box, Button, Link, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import {
  useCommunityOptInStatus,
  useOptInCommunity,
} from '../care-team/hooks/store/useCommunitySla';
import { useNavigate } from 'react-router';

export const CommunityOptIn = () => {
  const navigate = useNavigate();
  const { loading, optInCommunity } = useOptInCommunity();
  const communityOptedIn = useCommunityOptInStatus();
  if (communityOptedIn) {
    navigate(Routes.messages.community.index, { replace: true });
  }
  if (loading) {
    return <LoadingIndicator />;
  }
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        alignItems: 'center',
      }}
    >
      <ImageWithLoader
        src='/public/assets/images/illustration_community1.svg'
        style={{
          width: '100%',
          objectFit: 'contain',
        }}
        loaderSxProps={{ minHeight: 200 }}
      />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 8, px: 10 }}>
        <Typography
          variant={'h5'}
          sx={{ fontWeight: 600, textAlign: 'center' }}
        >
          <FormattedMessage id='community.setup-1.title' />
        </Typography>
        <Typography>
          <FormattedMessage id='community.setup-1.description' />
        </Typography>
        <Typography>
          <FormattedMessage id='community.setup-2.description' />
        </Typography>
        <Typography>
          <FormattedMessage id='community.setup-3.description' />
        </Typography>
        <Typography>
          <FormattedMessage
            id='community.setup-4.description'
            values={{
              tusLink: (text) => (
                <Link
                  rel='noopener'
                  variant='body1'
                  href={TERMS_CONDITIONS_URL}
                  target='_blank'
                >
                  {text}
                </Link>
              ),
            }}
          />
        </Typography>
      </Box>
      <Box sx={{ pb: 5 }}>
        <Button
          disableElevation
          onClick={optInCommunity}
          variant='contained'
          sx={{ px: 20, py: 4, borderRadius: 7.5 }}
        >
          <FormattedMessage id='actions.get-started' />
        </Button>
      </Box>
    </Box>
  );
};
